document.addEventListener("DOMContentLoaded", function () {
  const messages = document.querySelectorAll(".top-bar-message");

  let currentMessageIndex = 0;

  function displayNextMessage() {
    //Remueve todas las topbar-message-active de cada elemento
    messages.forEach((message) => {
      message.classList.remove("topbar-message-active");
    });

    //Agrega topbar-message-active al elemento actual
    messages[currentMessageIndex].classList.add("topbar-message-active");
    currentMessageIndex = (currentMessageIndex + 1) % messages.length;
  }

  displayNextMessage(); // Display initial message

  setInterval(displayNextMessage, 8000); // Change message every 8 seconds

  // Get the countdown elements
  const daysElement = document.getElementById("days-steven");
  const hoursElement = document.getElementById("hours-steven");
  const minutesElement = document.getElementById("minutes-steven");
  const secondsElement = document.getElementById("seconds-steven");

  // Function to update the countdown
  const countdown = document.querySelector(".countdown-steven");

  function updateCountup() {
    const finalDate = new Date("October 31, 2024 23:59:59"); // Start date for procrastination
    let currentDate = new Date(); // Current date
    let difference=finalDate.getTime() - currentDate.getTime()

    // Calculate the difference in milliseconds
    difference = finalDate.getTime() - currentDate.getTime();
    
    //If time runs out, eliminate countdown
    if(difference<0){
      clearInterval(contadorTopbar)
      daysElement.innerText = 0;
      hoursElement.innerText = 0;
      minutesElement.innerText = 0;
      secondsElement.innerText = 0;
      return
    }

    
    // Convert milliseconds to years, months, weeks, days, hours, minutes, and seconds
    const days = Math.floor(
      (difference % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24)
    );
    const hours = Math.floor(
      (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    // Display the countup
    daysElement.innerText = days;
    hoursElement.innerText = hours;
    minutesElement.innerText = minutes;
    secondsElement.innerText = seconds;
  }

  if (countdown) {
    // Update the countup every second
    var contadorTopbar=setInterval(updateCountup, 1000);
  }
});
